import type { TSPRoutingConfig } from 'bindings/optimization/TSPRoutingConfig';
import * as React from 'react';
import Input from '../../../../components_v2/input/Input';
import { Translate } from '../../../../styles/global/translate';
import { ReactStateType } from '../../Map';
import { ModalCalendarP, ModalCalendarSettingsDescriptionAndDropdown } from '../ModalCalendar';

export function genDefaultAdvancedSettings(): TSPRoutingConfig {
	return {};
}

export default function AdvancedSettingsConstraint(props: {
	advancedSettingsHook: ReactStateType<TSPRoutingConfig>
}) {
	const [advancedSettings, setAdvancedSettings] = props.advancedSettingsHook;

	return <>
		<ModalCalendarSettingsDescriptionAndDropdown>
			<label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
				<input
					type='checkbox'
					name='tsp_open_routes'
					id='tsp_open_routes'
					checked={advancedSettings.open_routes ?? false}
					onChange={e => setAdvancedSettings({ ...advancedSettings, open_routes: e.target.checked || undefined })}
				/>
				<ModalCalendarP><Translate id='tsp_open_routes' /></ModalCalendarP>
			</label>
		</ModalCalendarSettingsDescriptionAndDropdown>
		<ModalCalendarSettingsDescriptionAndDropdown>
			<ModalCalendarP><Translate id='tsp_flexible_lunch' /></ModalCalendarP>
			<Input
				inputStyle={{
					width: '100%',
					containerWidth: '100%',
				}}
				name='tsp_flexible_lunch_input'
				id='tsp_flexible_lunch_input'
				key='tsp_flexible_lunch_input'
				value={advancedSettings.lunch_duration_secs ? advancedSettings.lunch_duration_secs / 60 : undefined}
				onChange={(value) => {
					const minutes = parseInt(value);
					setAdvancedSettings({ ...advancedSettings, lunch_duration_secs: minutes > 0 ? minutes * 60 : undefined });
				}}
				type='number'
				min={1}
			/>
		</ModalCalendarSettingsDescriptionAndDropdown>
		<ModalCalendarSettingsDescriptionAndDropdown>
			<ModalCalendarP><Translate id='time_limit' /></ModalCalendarP>
			<Input
				inputStyle={{
					width: '100%',
					containerWidth: '100%',
				}}
				name='time_limit_input'
				id='time_limit_input'
				key='time_limit_input'
				value={advancedSettings.time_limit_seconds}
				onChange={(value) => {
					const seconds = parseInt(value);
					setAdvancedSettings({ ...advancedSettings, time_limit_seconds: seconds > 0 ? seconds : undefined });
				}}
				type='number'
				min={1}
			/>
		</ModalCalendarSettingsDescriptionAndDropdown>
	</>;
}
